import { jsx } from "react/jsx-runtime";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import { validateTidalLicense } from "../../base/index.js";
function LocationOnOutlined(props) {
  return /* @__PURE__ */ jsx(
    LocationOnOutlinedIcon,
    {
      "data-testid": "LocationOnOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "LocationOnOutlined",
      "data-tidal-icon-meta": "map,location,time"
    }
  );
}
LocationOnOutlined.tidalIconMeta = {
  categories: "map,location,time",
  name: "LocationOnOutlined"
};
validateTidalLicense();
export {
  LocationOnOutlined
};
//# sourceMappingURL=LocationOnOutlined.js.map
